(function(){
  if(sessionStorage.getItem("geo_redirect_done"))return;
  var p=window.location.pathname;
  var m=["/en-au","/en-eu","/en-sg","/ja-jp","/en-nz","/en-gb","/zh-sg"];
  for(var i=0;i<m.length;i++){
    if(p.indexOf(m[i])===0)return;
  }
  var u=window.Shopify.routes.root
    +"browsing_context_suggestions.json"
    +"?country[enabled]=true"
    +"&country[exclude]="+(window.Shopify.country||"");
  fetch(u)
    .then(function(r){return r.json()})
    .then(function(d){
      if(!d||!d.suggestions||d.suggestions.length===0)return;
      var s=d.suggestions[0];
      if(s&&s.parts&&s.parts.country){
        var cc=s.parts.country.handle;
        if(cc&&cc!==(window.Shopify.country||"")){
          sessionStorage.setItem("geo_redirect_done","1");
          var f=document.createElement("form");
          f.action="/localization";
          f.method="POST";
          f.hidden=true;
          var i1=document.createElement("input");
          i1.name="_method";
          i1.value="PUT";
          var i2=document.createElement("input");
          i2.name="country_code";
          i2.value=cc;
          f.appendChild(i1);
          f.appendChild(i2);
          document.body.appendChild(f);
          f.submit();
        }
      }
    })
    .catch(function(){});
})();